'use client';

import { c as _c } from "react/compiler-runtime";
import type { EmblaCarouselType } from 'embla-carousel';
import { useEffect, useState } from 'react';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { ProductRearBodyHeader } from '@/app/cv/components/sections/products/rear-body/header';
import { ProductRearBodyMainSlider } from '@/app/cv/components/sections/products/rear-body/sliders/main';
import { ProductRearBodyThumbSlider } from '@/app/cv/components/sections/products/rear-body/sliders/thumbs';
import type { ProductRearBodySectionProps } from '@/app/cv/components/sections/products/types';
import { useRevealAnim } from '@/app/hooks/useRevealAnim';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const REAR_BODY_SVG = {
  tractor: 'https://assets.isuzu-tis.com/rear_body_tractor_2f5cb23498.svg',
  truck: 'https://assets.isuzu-tis.com/rear_body_truck_7b307c4f0f.svg'
};
export const ProductRearBody = t0 => {
  const $ = _c(43);
  const {
    lead,
    title,
    description,
    buttons: t1,
    type: t2,
    items: t3,
    testId: t4
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const buttons = t5;
  const type = t2 === undefined ? "tractor" : t2;
  let t6;
  if ($[2] !== t3) {
    t6 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const items = t6;
  const testId = t4 === undefined ? "product-rear-body" : t4;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      defaultBaseDelay: 0.04
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  useRevealAnim(t7);
  const svgSrc = REAR_BODY_SVG[type ?? "tractor"];
  const [thumbEmblaApi, setThumbEmblaApi] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  let t8;
  let t9;
  if ($[5] !== thumbEmblaApi) {
    t8 = () => {
      if (!thumbEmblaApi) {
        return;
      }
      const onSelect = () => setCurrentIndex(thumbEmblaApi.selectedScrollSnap());
      thumbEmblaApi.on("select", onSelect);
      return () => {
        thumbEmblaApi.off("select", onSelect);
      };
    };
    t9 = [thumbEmblaApi];
    $[5] = thumbEmblaApi;
    $[6] = t8;
    $[7] = t9;
  } else {
    t8 = $[6];
    t9 = $[7];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[8] !== currentIndex || $[9] !== thumbEmblaApi) {
    t10 = () => {
      if (!thumbEmblaApi) {
        return;
      }
      if (thumbEmblaApi.slidesInView().includes(currentIndex)) {
        return;
      }
      thumbEmblaApi.scrollTo(currentIndex);
    };
    t11 = [currentIndex, thumbEmblaApi];
    $[8] = currentIndex;
    $[9] = thumbEmblaApi;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  useEffect(t10, t11);
  if (items.length === 0) {
    return null;
  }
  const t12 = `${testId}-section`;
  let t13;
  if ($[12] !== t12) {
    t13 = createDataAttributes({
      test: t12
    });
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== buttons || $[15] !== description || $[16] !== lead || $[17] !== title) {
    t14 = <ProductRearBodyHeader lead={lead} title={title} description={description} buttons={buttons} />;
    $[14] = buttons;
    $[15] = description;
    $[16] = lead;
    $[17] = title;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== currentIndex || $[20] !== items || $[21] !== svgSrc) {
    t15 = <ProductRearBodyMainSlider items={items} currentIndex={currentIndex} svgSrc={svgSrc} />;
    $[19] = currentIndex;
    $[20] = items;
    $[21] = svgSrc;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = items.length > 1;
  const t17 = !!thumbEmblaApi && currentIndex === 0;
  const t18 = !!thumbEmblaApi && currentIndex === items.length - 1;
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setCurrentIndex(_temp);
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== items.length) {
    t20 = () => setCurrentIndex(i_0 => Math.min(i_0 + 1, items.length - 1));
    $[24] = items.length;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  let t22;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = index => setCurrentIndex(index);
    t22 = api => setThumbEmblaApi(api);
    $[26] = t21;
    $[27] = t22;
  } else {
    t21 = $[26];
    t22 = $[27];
  }
  let t23;
  if ($[28] !== currentIndex || $[29] !== items || $[30] !== svgSrc || $[31] !== t16 || $[32] !== t17 || $[33] !== t18 || $[34] !== t20) {
    t23 = <ProductRearBodyThumbSlider items={items} currentIndex={currentIndex} hasMultipleItems={t16} svgSrc={svgSrc} prevBtnDisabled={t17} nextBtnDisabled={t18} onPrevButtonClick={t19} onNextButtonClick={t20} onThumbClick={t21} onEmblaInit={t22} />;
    $[28] = currentIndex;
    $[29] = items;
    $[30] = svgSrc;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
    $[34] = t20;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t15 || $[37] !== t23) {
    t24 = <Container>{t15}{t23}</Container>;
    $[36] = t15;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t13 || $[40] !== t14 || $[41] !== t24) {
    t25 = <Section id="rear-body" size="none" className="bg-gray-800 py-10 sm:py-14 md:py-16 lg:py-20" data-revealanim-group={true} {...t13}>{t14}{t24}</Section>;
    $[39] = t13;
    $[40] = t14;
    $[41] = t24;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  return t25;
};
function _temp(i) {
  return Math.max(i - 1, 0);
}